<template>
  <div>
    <div class="stepslider-component">
      <div class="stepslider-wrapper">
        <div ref="stepslider"></div>
      </div>
    </div>
  </div>
</template>

<script>
import noUiSlider from 'nouislider';
import 'nouislider/dist/nouislider.css';

export default {
  data() {
    return {
      sliderValue: 0,
    };
  },

  mounted() {
    this.initStepSlider();
  },
  methods: {
    initStepSlider() {
      const sliderElement = this.$refs.stepslider;
      noUiSlider.create(sliderElement, {
        start: [0],
        range: {
          min: 0,
          max: 2
        },
        step: 1,
        tooltips: false,
        format: {
          to: (value) => Math.round(value),
          from: (value) => Number(value),
        },
        pips: {
          mode: 'steps',
          density: 3,
          filter: (value) => {
            return value % 1 === 0 ? 1 : -1;
          },
          format: {
            to: (value) => {
              switch (value) {
                case 0: return 'Hauptsache günstig';
                case 1: return 'Durschnittlicher Standard';
                case 2: return 'Überdurchschnittliche Schärfe';
              }
            }
          }
        }
      });
      sliderElement.noUiSlider.on('update', (values, handle) => {
        this.sliderValue = Number(values[handle]);
        this.$emit('update-slider', this.sliderValue);
      });
    }
  }
};
</script>

<style>
.stepslider-component {
  width: 70%;
  margin: 0 auto;
  margin-bottom: 40%;
  margin-top: 5%;
}

.stepslider-wrapper {
  width: 100%;
}

.noUi-handle {
  background-color: #E7EFFB;
}

.noUi-value {
  font-size: 16px;
  color: #333;
  text-align: center;
  white-space: normal;
  width: 80px;
  display: block;
  margin-top: 10px;
}

.noUi-value:before {
  content: '';
}

.noUi-marker {
  background-color: #333;
}
</style>